module.exports = __webpack_public_path__ + "82f26cae46d4573148111fba17e2fd5e.png";